import React from 'react';
// components
import { FormattedMessage } from 'react-intl';
// constants
import { farmTypes } from 'constants.js';
// utils
import { formValueSelector } from 'redux-form';

export const treatmentPeriods = ['before', 'between', 'after', 'on', 'flexible'];
export const reminderPeriods = ['between', 'on'];
export const treatmentPeriodUnits = [
  { label: <FormattedMessage id="general.day" />, value: 'day' },
  { label: <FormattedMessage id="general.week" />, value: 'week' },
  { label: <FormattedMessage id="general.calendar" />, value: 'date_range' },
];

export const reminderPeriodUnits = [
  { label: <FormattedMessage id="general.calendar" />, value: 'date_range' },
];

// Production phases a sow unit protocol can be inherited into, every one selected by default
export const applicablePhases = farmTypes.filter(({ value }) => ['n', 'f', 'wf'].includes(value));
export const defaultApplicablePhases = applicablePhases.map(({ value }) => value);

export const treatmentProtocolFormName = 'treatment-protocol-form';
export const treatmentProtocolFormSelector = formValueSelector(treatmentProtocolFormName);
